
const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 to-slate-800 text-white py-24">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/d7bce9b309117e23f445ea0035299349.jpg')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold mb-6">
            Let's Discuss Your
            <span className="text-teal-400"> Global Expansion</span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Ready to take your business international? Our team of experts is here to guide 
            you through every step of your global expansion journey.
          </p>
          <div className="flex flex-wrap gap-6 text-sm">
            <div className="flex items-center">
              <i className="ri-time-line text-teal-400 mr-2"></i>
              <span>Free 30-Minute Consultation</span>
            </div>
            <div className="flex items-center">
              <i className="ri-user-line text-teal-400 mr-2"></i>
              <span>Expert Strategy Session</span>
            </div>
            <div className="flex items-center">
              <i className="ri-roadmap-line text-teal-400 mr-2"></i>
              <span>Custom Roadmap</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
